import generateUtilityClasses from "../../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
const boxClasses = generateUtilityClasses("MuiBox", ["root"]);
const boxClasses$1 = boxClasses;
export {
  boxClasses$1 as default
};
//# sourceMappingURL=boxClasses.es.js.map
